import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function DogDisplay({
  dog,
  playerId,
  selectedBackgroundUrl,
  setSelectedBackgroundUrl,
  position,
  setPosition,
  scale,
  setScale,
  availableBackgrounds = [],
  saveChanges, // Added prop
  submitImageUpdate,
  updateCallName,
  dogName,
  backgroundWidth = 600,
  backgroundHeight = 600,
  isInteractionLevels = false,
  failedImages = new Set(),
}) {
  const [showManageDog, setShowManageDog] = useState(false);

  const fallbackBackground = 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e278b58f-e271-405b-8060-c4679e13d416/djax514-2e3f5872-3a2a-4fdb-b4b1-acb0fc62c074.png/v1/fill/w_894,h_894/corn_field_fence_by_dogfanciersguild_djax514-pre.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTEzMCIsInBhdGgiOiJcL2ZcL2UyNzhiNThmLWUyNzEtNDA1Yi04MDYwLWM0Njc5ZTEzZDQxNlwvZGpheDUxNC0yZTNmNTg3Mi0zYTJhLTRmZGItYjRiMS1hY2IwZmM2MmMwNzQucG5nIiwid2lkdGgiOiI8PTExMzAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.i9aJ6BFFgqbgM8vihlz58lc5LWX0i5iB5ow2TlZWtkM'; // Use working URL

  const handleScaleChange = (change) => {
    setScale((prev) => {
      const newScale = Math.min(Math.max(prev + change, 0.5), 2);
      return newScale;
    });
  };

  if (!dog || !dog.registeredName) {
    return <p>Loading...</p>;
  }

  const getBackgroundUrl = () => {
    console.log('getBackgroundUrl:', { selectedBackgroundUrl, hasFailed: failedImages.has(selectedBackgroundUrl) });
    if (!selectedBackgroundUrl || failedImages.has(selectedBackgroundUrl)) {
      return fallbackBackground;
    }
    return selectedBackgroundUrl;
  };

  const handleImageError = (e, url) => {
    console.error('Image failed to load:', url);
    failedImages.add(url);
    e.target.src = fallbackBackground;
  };

  const containerStyle = {
    position: 'relative',
    width: `${backgroundWidth}px`,
    height: `${backgroundHeight}px`,
    margin: '0 auto',
    overflow: 'hidden',
    border: '1px solid #ccc',
    borderRadius: '8px',
    backgroundColor: '#f0f0f0',
  };

  return (
    <div style={{ margin: '20px 0', textAlign: 'center' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {!isInteractionLevels && (
          <Link
            to={{
              pathname: `/dog/${dog.dogId}/interaction-levels`,
              state: { dogName: dogName || dog.registeredName || 'Unknown Dog' },
            }}
            style={{
              fontSize: '14px',
              color: '#1e88e5',
              textDecoration: 'none',
              marginRight: '20px',
            }}
          >
            ← <p>Interaction Levels</p><p>and</p><p>Health</p>
          </Link>
        )}
        <div style={containerStyle}>
          {failedImages.has(fallbackBackground) ? (
            <div
              style={{
                width: '100%',
                height: '100%',
                backgroundColor: '#f0f0f0',
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#888',
              }}
            >
              Background Unavailable
            </div>
          ) : (
            <img
              src={getBackgroundUrl()}
              alt="Dog Background"
              className="dog-background"
              crossOrigin="anonymous"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 1,
              }}
              onError={(e) => handleImageError(e, selectedBackgroundUrl)}
            />
          )}
          {dog.artUrl && !failedImages.has(dog.artUrl) ? (
            <img
              src={dog.artUrl}
              alt={dog.registeredName}
              className="dog-art"
              crossOrigin="anonymous"
              style={{
                position: 'absolute',
                maxWidth: '50%',
                maxHeight: '50%',
                left: '50%',
                top: '50%',
                transform: `translate(-50%, -50%) translate(${position.x}px, ${position.y}px) scale(${scale})`,
                transformOrigin: 'center',
                zIndex: 2,
              }}
              onError={(e) => {
                console.error('Dog image failed to load:', dog.artUrl);
                failedImages.add(dog.artUrl);
                e.target.style.display = 'none';
              }}
            />
          ) : (
            <div
              className="dog-art"
              style={{
                position: 'absolute',
                width: '200px',
                height: '200px',
                left: '50%',
                top: '50%',
                transform: `translate(-50%, -50%) translate(${position.x}px, ${position.y}px) scale(${scale})`,
                transformOrigin: 'center',
                backgroundColor: '#ccc',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2,
                color: '#888',
              }}
            >
              No Image
            </div>
          )}
        </div>
        {!isInteractionLevels && (
          <Link
            to={{
              pathname: `/dog/${dog.dogId}/equipment`,
              state: { dogName: dogName || dog.registeredName || 'Unknown Dog' },
            }}
            style={{
              fontSize: '14px',
              color: '#1e88e5',
              textDecoration: 'none',
              marginLeft: '20px',
            }}
          >
            → <p>Equipment </p><p>and</p><p> Companions</p>
          </Link>
        )}
      </div>
      {!isInteractionLevels && playerId === dog.playerId && (
        <>
          <div style={{ margin: '20px 0' }}>
            <button
              onClick={() => setShowManageDog(!showManageDog)}
              style={{
                padding: '8px 16px',
                backgroundColor: '#1E88E5',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '16px',
              }}
            >
              {showManageDog ? 'Hide Manage Dog' : 'Manage Dog'}
            </button>
          </div>
          {showManageDog && (
            <div style={{ marginBottom: '20px' }}>
              <div className="background-selector" style={{ marginBottom: '20px' }}>
                <label htmlFor="background-select" style={{ marginRight: '10px', fontSize: '16px' }}>
                  Choose Background:
                </label>
                <select
                  id="background-select"
                  value={selectedBackgroundUrl || ''}
                  onChange={(e) => {
                    const newUrl = e.target.value;
                    console.log('Selected background URL:', newUrl);
                    if (!failedImages.has(newUrl)) {
                      setSelectedBackgroundUrl(newUrl);
                    }
                  }}
                  style={{
                    padding: '8px',
                    fontSize: '16px',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                  }}
                >
                  {availableBackgrounds.length === 0 && (
                    <option value="" disabled>
                      No Backgrounds Available
                    </option>
                  )}
                  {availableBackgrounds.map((bg) => (
                    <option key={bg.id} value={bg.url} disabled={failedImages.has(bg.url)}>
                      {bg.name} {failedImages.has(bg.url) ? '(Failed)' : ''}
                    </option>
                  ))}
                </select>
              </div>
              <div className="position-controls" style={{ marginBottom: '20px' }}>
                <button
                  onClick={() => setPosition((prev) => ({ ...prev, x: prev.x - 10 }))}
                  style={{
                    marginRight: '10px',
                    padding: '8px 16px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '14px',
                  }}
                >
                  Left
                </button>
                <button
                  onClick={() => setPosition((prev) => ({ ...prev, x: prev.x + 10 }))}
                  style={{
                    marginRight: '10px',
                    padding: '8px 16px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '14px',
                  }}
                >
                  Right
                </button>
                <button
                  onClick={() => setPosition((prev) => ({ ...prev, y: prev.y - 10 }))}
                  style={{
                    marginRight: '10px',
                    padding: '8px 16px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '14px',
                  }}
                >
                  Up
                </button>
                <button
                  onClick={() => setPosition((prev) => ({ ...prev, y: prev.y + 10 }))}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '14px',
                  }}
                >
                  Down
                </button>
<button
  onClick={() => handleScaleChange(0.1)}
  style={{
    margin: '5px',
    padding: '5px 10px',
    backgroundColor: '#4CAF50',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '12px'
  }}
  onMouseOver={(e) => (e.target.style.opacity = '0.9')}
  onMouseOut={(e) => (e.target.style.opacity = '1')}
>
  Bigger
</button>

<button
  onClick={() => handleScaleChange(-0.1)}
  style={{
    margin: '5px',
    padding: '5px 10px',
    backgroundColor: '#4CAF50',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '12px'
  }}
  onMouseOver={(e) => (e.target.style.opacity = '0.9')}
  onMouseOut={(e) => (e.target.style.opacity = '1')}
>
  Smaller
</button>
              </div>
              <div className="dog-management-controls" style={{ marginBottom: '20px' }}>
                <button
                  onClick={submitImageUpdate}
                  style={{
                    marginRight: '10px',
                    padding: '8px 16px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '14px',
                  }}
                >
                  Request Image Update
                </button>
                <button
                  onClick={updateCallName}
                  style={{
                    marginRight: '10px',
                    padding: '8px 16px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '14px',
                  }}
                >
                  Edit Call Name
                </button>
                <button
                  onClick={saveChanges}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#1E88E5',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '14px',
                  }}
                >
                  Save Changes
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default DogDisplay;